import { DASHBOARD } from "../dashboard/dashboard.query";
import { GET_ALL_PETS } from "../pet-list/pet-list.query";
import { IPetUpdateResponse } from "./pet-update.interface";
import { PET_UPDATE } from "./pet-update.mutation";
import { PetBirthdayUpdateType, PetUpdateFormType } from "./pet-update.schema";
import { mapToPetBirthdayUpdateRequest, mapToPetUpdateRequest } from "./pet-update.mapper";
import { petActions } from "../../state/pet";
import { toastMessageActions } from "../../state/request";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { useMutation } from "@apollo/client";

export const usePetUpdate = () => {
  const dispatch = useDispatch();
  const refetchQueries = [
    { query: DASHBOARD },
    { query: GET_ALL_PETS },
  ];
  const [update, { data: petUpdated, loading, error }] = useMutation<{ updatePetV2: IPetUpdateResponse }>(PET_UPDATE, {
    refetchQueries,
    awaitRefetchQueries: true,
  });

  const petUpdate = (id:string, pet: PetUpdateFormType, file?: File | string) => {
    const petData = mapToPetUpdateRequest(pet);

    update({
      variables: {
        id,
        file,
        pet: petData,
      },
    });
  };

  const petBirthdayUpdate = (id:string, pet: PetBirthdayUpdateType, file?: File | string) => {
    const petData = mapToPetBirthdayUpdateRequest(pet);

    update({
      variables: {
        id,
        file,
        pet: petData,
      },
    });
  };

  useEffect(() => {
    dispatch( toastMessageActions.setGlobalLoading(loading));
  }, [loading]);

  useEffect(() => {
    if (petUpdated) {
      dispatch(petActions.setPetInfo(petUpdated.updatePetV2.pet));
      dispatch(toastMessageActions.setGlobalAlert({
        severity: "success",
        message: "Your pet has been updated successfully",
      }));
    }
  }, [petUpdated]);

  return {
    petUpdated,
    petUpdate,
    petBirthdayUpdate,
    error,
  };
};
